module.exports = {"pageTitleText":"System Log","message":"Message","level":"Level","category":"Category","timestamp":"Time"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/systemLog.json
// module id = DSug
// module chunks = 3